import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g>
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        fillOpacity="1"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 880.825c0-1.669-.093-2.874-.093-4.542h10.634v-8.211c-6.732.217-14.017.717-20.321-2.061-4.88-2.678-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.837 12.418-9.778 19.684-12.949 7.417 3.225 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.997-2.987 10.277-8.093 11.367-5.71 1.581-11.49 1.3-17.354 1.057v8.211h10.058c0 1.668.093 2.873.093 4.542-7.897-.056-17.336-.056-25.866 0z"
                    ></path>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.72185 1.38533)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M23.835 544.63q0 .354-.127.623-.34.113-.735.113h-10.44q-.934 0-.934-.99 0-.17.029-.538.028-.382.028-.58 0-.933.82-.933H16v-13.071h-4.3q-.906 0-.906-.99 0-.212.043-.68.056-.48.056-.72 0-.482.905-.482.255 0 .962.057.708.042 1.104.042 2.263 0 2.744-1.57h2.702v17.414q.948 0 2.037-.057 1.103-.07 1.315-.07.82 0 1.019.438.155.382.155 1.994z"
                            fontSize="28.97"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.69919 1.43023)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M38.073 518.577q0 9.67-6.685 9.67-6.78 0-6.78-9.724 0-10.089 6.915-10.089 6.55 0 6.55 10.143zm-3.512-.284q0-6.928-3.227-6.928-1.891 0-2.688 2.741-.5 1.73-.5 4.309 0 6.928 3.188 6.928 1.904 0 2.714-2.728.513-1.756.513-4.322z"
                            fontSize="27.659"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.72185 -1.38533)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-300.333-734.284q0 .353-.127.622-.34.113-.736.113h-10.44q-.933 0-.933-.99 0-.17.029-.538.028-.381.028-.58 0-.933.82-.933h3.523v-13.07h-4.3q-.906 0-.906-.991 0-.212.042-.679.057-.48.057-.721 0-.481.905-.481.255 0 .962.056.707.043 1.104.043 2.263 0 2.744-1.57h2.702v17.413q.947 0 2.037-.057 1.103-.07 1.315-.07.82 0 1.019.438.155.382.155 1.995z"
                            fontSize="28.97"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.69919 -1.43023)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-296.6-720.192q0 9.67-6.686 9.67-6.78 0-6.78-9.724 0-10.09 6.915-10.09 6.55 0 6.55 10.144zm-3.512-.284q0-6.928-3.228-6.928-1.89 0-2.688 2.741-.5 1.729-.5 4.309 0 6.928 3.188 6.928 1.904 0 2.715-2.728.513-1.756.513-4.322z"
                            fontSize="27.659"
                        ></path>
                    </g>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 890.9c0 1.668-.093 2.873-.093 4.541h10.634v8.211c-6.732-.216-14.017-.716-20.321 2.061-4.88 2.679-6.227 8.913-5.243 14.038.842 5.783 4.057 10.918 8.25 14.873 5.458 5.838 12.418 9.778 19.684 12.949 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.093-11.367-5.71-1.581-11.49-1.3-17.354-1.057v-8.211h10.058c0-1.668.093-2.873.093-4.541-7.897.055-17.336.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 880.825c0-1.669-.092-2.874-.092-4.542h10.634v-8.211c-6.732.217-14.018.717-20.322-2.061-4.88-2.678-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.837 12.417-9.778 19.684-12.949 7.417 3.225 14.53 7.294 20.057 13.285 4.978 4.678 8.294 11.29 8.192 18.212.108 4.997-2.987 10.277-8.092 11.367-5.711 1.581-11.491 1.3-17.354 1.057v8.211h10.058c0 1.668.092 2.873.092 4.542-7.896-.056-17.336-.056-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 814.076c0-1.668-.092-2.873-.092-4.541h10.634v-8.211c-6.732.216-14.018.716-20.322-2.061-4.88-2.679-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.838 12.417-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.294 11.29 8.192 18.212.108 4.996-2.987 10.276-8.092 11.367-5.711 1.581-11.491 1.3-17.354 1.057v8.211h10.058c0 1.668.092 2.873.092 4.541-7.896-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 814.076c0-1.668-.093-2.873-.093-4.541h10.634v-8.211c-6.732.216-14.017.716-20.321-2.061-4.88-2.679-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.838 12.418-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.996-2.987 10.276-8.093 11.367-5.71 1.581-11.49 1.3-17.354 1.057v8.211h10.058c0 1.668.093 2.873.093 4.541-7.897-.055-17.336-.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 847.45c0-1.668-.093-2.873-.093-4.54h10.635v-8.212c-6.732.217-14.018.717-20.322-2.061-4.88-2.678-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.838 12.418-9.778 19.684-12.949 7.417 3.225 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.996-2.987 10.276-8.092 11.367-5.711 1.581-11.492 1.3-17.354 1.057v8.211h10.058c0 1.668.092 2.873.092 4.541-7.897-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M12.899 780.702c0-.556-.031-.958-.031-1.514h3.545v-2.737c-2.244.072-4.673.24-6.774-.687-1.627-.893-2.076-2.97-1.748-4.68.281-1.927 1.353-3.638 2.75-4.957 1.82-1.946 4.14-3.26 6.562-4.316 2.472 1.075 4.843 2.431 6.685 4.428 1.66 1.56 2.765 3.764 2.731 6.071.036 1.665-.995 3.425-2.697 3.789-1.904.527-3.83.434-5.785.352v2.737h3.353c0 .556.03.958.03 1.514a669.463 669.463 0 00-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 957.648c0 1.668-.093 2.873-.093 4.541h10.634v8.212c-6.732-.217-14.017-.717-20.321 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.918 8.25 14.873 5.458 5.837 12.418 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.093-11.366-5.71-1.582-11.49-1.301-17.354-1.057v-8.212h10.058c0-1.668.093-2.873.093-4.54-7.897.055-17.336.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 924.274c0 1.668-.093 2.873-.093 4.541h10.635v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.918 8.25 14.873 5.458 5.837 12.418 9.777 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.492-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.541-7.897.056-17.336.056-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 957.648c0 1.668-.092 2.873-.092 4.541h10.634v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.226 8.913-5.242 14.039.842 5.782 4.056 10.918 8.25 14.873 5.458 5.837 12.417 9.777 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.977-4.678 8.294-11.29 8.192-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.491-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.54-7.897.055-17.336.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 890.9c0 1.668-.092 2.873-.092 4.541h10.634v8.211c-6.732-.216-14.017-.716-20.322 2.061-4.88 2.679-6.226 8.913-5.242 14.038.842 5.783 4.057 10.918 8.25 14.873 5.458 5.838 12.417 9.778 19.684 12.949 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.294-11.29 8.192-18.212.108-4.996-2.987-10.276-8.092-11.367-5.71-1.581-11.491-1.3-17.354-1.057v-8.211h10.058c0-1.668.092-2.873.092-4.541-7.896.055-17.335.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M212.488 991.022c0 .556-.031.958-.031 1.514h3.545v2.737c-2.244-.072-4.673-.239-6.774.687-1.627.893-2.076 2.971-1.748 4.68.28 1.927 1.352 3.639 2.75 4.957 1.82 1.946 4.14 3.26 6.562 4.316 2.472-1.075 4.843-2.431 6.685-4.428 1.66-1.56 2.765-3.763 2.731-6.07.036-1.666-.996-3.426-2.697-3.79-1.904-.527-3.83-.433-5.785-.352v-2.737h3.353c0-.556.03-.958.03-1.514-2.632.019-5.778.019-8.621 0z"
                    ></path>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
